"use client";

import { useState } from "react";
import type { PartnerView } from "./partnerList";

function initials(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
}

const tileClass =
  "partner-tile box-border flex h-[120px] w-[200px] shrink-0 items-center justify-center rounded-home-16 border-[1.5px] border-home-navy bg-home-cream px-6 py-[18px] max-sm:h-[100px] max-sm:w-[160px]";

export function PartnerTile({
  partner,
  linkLabel,
}: {
  partner: PartnerView;
  linkLabel: string;
}) {
  const [failed, setFailed] = useState(false);
  const showLogo = Boolean(partner.src) && !failed;

  const content = showLogo ? (
    <img
      src={partner.src ?? ""}
      alt={partner.name}
      width={152}
      height={84}
      className="partner-logo max-h-full max-w-full object-contain"
      onError={() => setFailed(true)}
    />
  ) : (
    <span className="flex max-w-full flex-col items-center gap-1.5 text-center">
      <span className="flex h-11 w-11 items-center justify-center rounded-full border-[1.5px] border-home-navy text-[14px] font-bold text-home-navy">
        {initials(partner.name)}
      </span>
      <span className="max-w-full truncate text-[13px] font-semibold leading-tight text-home-navy">
        {partner.name}
      </span>
    </span>
  );

  if (partner.href) {
    return (
      <a
        href={partner.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={linkLabel}
        className={tileClass}
      >
        {content}
      </a>
    );
  }

  return <div className={tileClass}>{content}</div>;
}
